import pkg from "../package.json";

export const APP_VERSION = pkg.version;

let _AUTH_BASE_URL = "";
let _DATA_BASE_URL = "";

(() => {
  const regexParse = new RegExp("([a-z-0-9]{2,63}).([a-z.]{2,5})$");
  const p = regexParse.exec(window.location.hostname);

  if (window.location.hostname === "localhost" || p === null) {
    // _AUTH_BASE_URL = "http://localhost:8081/api/";
    // _DATA_BASE_URL = "http://localhost:8080/api/";
    // _AUTH_BASE_URL = "https://hsa-auth-api.staging.hotsauceyourtops.com/api/";
    // _DATA_BASE_URL = "https://hsa-data-api.staging.hotsauceyourtops.com/api/";
    _AUTH_BASE_URL = "https://hsa-auth-api.hotsauceyourtops.com/api/";
    _DATA_BASE_URL = "https://hsa-data-api.hotsauceyourtops.com/api/";
  } else if (
    window.location.hostname === "customer.staging.hotsauceyourtops.com"
  ) {
    _AUTH_BASE_URL = "https://hsa-auth-api.staging.hotsauceyourtops.com/api/";
    _DATA_BASE_URL = "https://hsa-data-api.staging.hotsauceyourtops.com/api/";
  } else if (window.location.hostname === "customer.hotsauceyourtops.com") {
    _AUTH_BASE_URL = "https://hsa-auth-api.hotsauceyourtops.com/api/";
    _DATA_BASE_URL = "https://hsa-data-api.hotsauceyourtops.com/api/";
  }
})();

export const AUTH_BASE_URL = _AUTH_BASE_URL;
export const DATA_BASE_URL = _DATA_BASE_URL;
